import { get, has } from 'lodash-es';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab, TabBody, Button, MenuList, MenuListItem } from 'react95';
import { userSelector } from '../../selectors/authSelectors';
import { getAvailableActions, isActionDisabled } from '../../utils/taskUtils';
import { setModalType } from '../../actions/taskDetailActions';
import './TaskDetailActions.scss';
import { useOutsideClick } from '../../utils/componentUtils';
import { TASK_DETAIL_ACTIONS } from '../../global/Environment';
import { useGetTaskQuery } from '../../api/opsSystemApi';
import { useParams } from 'react-router-dom';

const ACTION_OPTIONS = {
  [TASK_DETAIL_ACTIONS.CONFIRM_AMOUNTS]: [
    {
      action: TASK_DETAIL_ACTIONS.CONFIRM_AMOUNTS,
      description: 'Update stage, run amounts job, and notify user',
      primary: true
    },
    {
      action: TASK_DETAIL_ACTIONS.CONFIRM_AMOUNTS_NO_TEXT_EMAIL,
      description: 'Update stage and run amounts job without notifying user',
      primary: false
    },
    {
      action: TASK_DETAIL_ACTIONS.UPDATE_AMOUNTS,
      description: 'Run amounts job only (no stage change)',
      primary: false
    }
  ],
  'Drake Upload': [
    {
      action: TASK_DETAIL_ACTIONS.UPLOAD_TAX_DATA,
      primary: true
    },
    {
      action: TASK_DETAIL_ACTIONS.UPLOAD_DEPOSIT_WITHDRAWAL_FORMS,
      description: 'upload only deposit / withdrawal payment info & move user to final review',
      primary: false
    }
  ]
};

const TaskDetailActions = ({ user, setModalType }) => {
  const [actionTab, setActionTab] = useState(0);
  const [multiOptionsMenuOpen, setMultiOptionsMenuOpen] = useState(false);

  const { taskId } = useParams();
  const { data: task = {}, isLoading: isTaskLoading } = useGetTaskQuery(taskId);

  const confirmAmountsDropdownRef = useRef(null);
  useOutsideClick(confirmAmountsDropdownRef, () => setMultiOptionsMenuOpen(false));

  return (
    <>
      <Tabs value={actionTab} onChange={(value) => setActionTab(value)}>
        <Tab value={0}>Primary</Tab>
        <Tab value={1}>Other</Tab>
        <Tab value={2}>Tax Expert Escalations</Tab>
      </Tabs>
      <TabBody>
        <div className='task-detail-actions'>
          {getAvailableActions(actionTab).map((action, i) =>
            has(ACTION_OPTIONS, action) ? (
              <div key={i} className='task-detail-actions-multi' ref={confirmAmountsDropdownRef}>
                <Button
                  disabled={
                    isTaskLoading ||
                    get(ACTION_OPTIONS, action).every((opt) => isActionDisabled(opt.action, task, user))
                  }
                  size='lg'
                  onClick={() => setMultiOptionsMenuOpen(!multiOptionsMenuOpen)}>
                  <span>{action} +</span>
                </Button>
                {multiOptionsMenuOpen && (
                  <MenuList onClick={() => setMultiOptionsMenuOpen(false)}>
                    {get(ACTION_OPTIONS, action).map((opt) => (
                      <MenuListItem
                        key={opt.action}
                        primary={opt.primary}
                        disabled={isActionDisabled(opt.action, task, user)}
                        onClick={() => setModalType(opt.action)}>
                        <div className='task-detail-actions-multi-label'>{opt.action}</div>
                        <div className='task-detail-actions-multi-info'>{opt.description}</div>
                      </MenuListItem>
                    ))}
                  </MenuList>
                )}
              </div>
            ) : (
              <Button
                key={i}
                disabled={isTaskLoading || isActionDisabled(action, task, user)}
                onClick={() => setModalType(action)}
                size='lg'>
                <span>{action}</span>
              </Button>
            )
          )}
        </div>
      </TabBody>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: userSelector(state)
});

const mapDispatchToProps = {
  setModalType
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetailActions);
